import React from 'react'

const TextArea = React.forwardRef((props, ref) => (
  <div className='row'>
    <label className='reconcile-label col-lg-4'>{props.label}</label>
    <div className='col-lg-7'>
      <textarea
        ref={ref}
        name={props.name}
        rows='5'
        className='form-control'
        onChange={props.onChange}
      />
    </div>
  </div>
))

export default TextArea
